import React from 'react';
import Logintest from '../pages/Logintest';
import Dashboardtest from '../pages/Dashboardtest';
import DemoForm from '../pages/DemoForm';

import Login from '../pages/Login'
import Dashboard from '../pages/Dashboard'
import Connectors from '../pages/Connectors'
import AddConnector from '../pages/AddConnector'
import Templates from '../pages/Templates'
import AddTemplate from '../pages/AddTemplate'
import OptinOptoutPolicies from '../pages/OptinOptoutPolicies'
import AddOptinOptoutPolicy from '../pages/AddOptinOptoutPolicy'
import Senders from '../pages/Senders'
import AddSender from '../pages/AddSender'
import Logging from '../pages/Logging'
import OptOutSearch from '../pages/OptOutSearch';
import Users from '../pages/Users';
import AuditLog from '../pages/AuditLog';
import AuditLogDetail from '../pages/AuditLogDetail';

const routes = [

  {
    path: '/',
    element: <Dashboard />,
    protected: true,
  },
  {
    path: '/logintest',
    element: <Logintest />,
    protected: false,
  },
  {
    path: '/dashboardtest',
    element: <Dashboardtest />,
    protected: false,
  },
  {
    path: '/demoform',
    element: <DemoForm />,
    protected: false,
  },
  {
    path: '/login',
    element: <Login />,
    protected: false,
  },

  {
    path: '/connectors',
    element: <Connectors />,
    protected: true,
  },
  {
    path: '/add-connector',
    element: <AddConnector />,
    protected: true,
  },
  {
    path: '/edit-connector/:id',
    element: <AddConnector />,
    protected: true,
  },
  {
    path: '/templates',
    element: <Templates />,
    protected: true,
  },
  {
    path: '/add-template',
    element: <AddTemplate />,
    protected: true,
  },
  {
    path: '/edit-template/:id',
    element: <AddTemplate />,
    protected: true,
  },
  {
    path: '/optin-optout-policies',
    element: <OptinOptoutPolicies />,
    protected: true,
  },
  {
    path: '/add-optin-optout-policy',
    element: <AddOptinOptoutPolicy />,
    protected: true,
  },
  {
    path: '/edit-optin-optout-policy/:id',
    element: <AddOptinOptoutPolicy />,
    protected: true,
  },
  {
    path: '/senders',
    element: <Senders />,
    protected: true,
  },
  {
    path: '/add-sender',
    element: <AddSender />,
    protected: true,
  },
  {
    path: '/edit-sender/:id',
    element: <AddSender />,
    protected: true,
  },
  {
    path: '/logging',
    element: <Logging />,
    protected: true,
  },
  {
    path: '/optouts',
    element: <OptOutSearch />,
    protected: true,
  },
  {
    path: '/users',
    element: <Users />,
    protected: true,
  },
  {
    path: '/audit-log',
    element: <AuditLog />,
    protected: true,
  },
  {
    path: '/audit-log/:id',
    element: <AuditLogDetail />,
    protected: true,
  },
];

export default routes;
